import React, { useState } from "react";

function Modal({
  isOpen,
  onClose,
  title,
  inputValue1 = "",
  inputValue2 = "",
  inputValue4 = "",
  setInputValue1,
  setInputValue2,
  setInputValue4,
  onSave,
  priceType,
  setPriceType,
  singlePrice,
  setSinglePrice,
  smallPrice,
  setSmallPrice,
  mediumPrice,
  setMediumPrice,
  largePrice,
  setLargePrice,
}) {
  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const handleValidation = () => {
    const newErrors = {
      inputValue1: !inputValue1.trim(),
      inputValue2: !inputValue2.trim(),
      inputValue4: !inputValue4.trim(),
      singlePrice: priceType === "single" && !singlePrice.trim(),
      smallPrice: priceType === "size" && !smallPrice.trim(),
      mediumPrice: priceType === "size" && !mediumPrice.trim(),
      largePrice: priceType === "size" && !largePrice.trim(),
    };
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => !error);
  };

  const handleSave = () => {
    if (handleValidation()) {
      onSave();
    }
  };

  const handleNumberInputChange = (setter) => (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d{0,2}$/.test(value)) {
      setter(value);
    }
  };

  const handleNumberInputBlur = (setter) => (e) => {
    const value = e.target.value;
    setter(value.replace(/[^0-9.]/g, ""));
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <input
              type="text"
              className={`form-control mb-2 ${errors.inputValue1 ? "is-invalid" : ""}`}
              placeholder="Item Name"
              value={inputValue1}
              onChange={(e) => setInputValue1(e.target.value)}
            />
            {errors.inputValue1 && <div className="invalid-feedback">Item name is required.</div>}

            <input
              type="text"
              className={`form-control mb-2 ${errors.inputValue2 ? "is-invalid" : ""}`}
              placeholder="Quantity"
              value={inputValue2}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) { // Allows only digits (0-9)
                  setInputValue2(value);
                }
              }}
            />
            {errors.inputValue2 && <div className="invalid-feedback">Quantity is required.</div>}

            <input
              type="text"
              className={`form-control mb-2 ${errors.inputValue4 ? "is-invalid" : ""}`}
              placeholder="Category"
              value={inputValue4}
              onChange={(e) => setInputValue4(e.target.value)}
            />
            {errors.inputValue4 && <div className="invalid-feedback">Category is required.</div>}

            <div className="mb-2">
              <label>Price Type:</label>
              <div className="form-check">
                <input
                  type="radio"
                  name="priceType"
                  value="single"
                  checked={priceType === "single"}
                  onChange={() => setPriceType("single")}
                  className="form-check-input"
                />
                <label className="form-check-label">Single Price</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  name="priceType"
                  value="size"
                  checked={priceType === "size"}
                  onChange={() => setPriceType("size")}
                  className="form-check-input"
                />
                <label className="form-check-label">Size-Based Pricing</label>
              </div>
            </div>

            {priceType === "single" && (
              <input
                type="text"
                className={`form-control mb-2 ${errors.singlePrice ? "is-invalid" : ""}`}
                placeholder="Price"
                value={singlePrice}
                onChange={handleNumberInputChange(setSinglePrice)}
                onBlur={handleNumberInputBlur(setSinglePrice)}
              />
            )}
            {priceType === "size" && (
              <>
              <p>If size is not available input 0</p>
                <input
                  type="text"
                  className={`form-control mb-2 ${errors.smallPrice ? "is-invalid" : ""}`}
                  placeholder="Small Price"
                  value={smallPrice}
                  onChange={handleNumberInputChange(setSmallPrice)}
                  onBlur={handleNumberInputBlur(setSmallPrice)}
                />
                <input
                  type="text"
                  className={`form-control mb-2 ${errors.mediumPrice ? "is-invalid" : ""}`}
                  placeholder="Medium Price"
                  value={mediumPrice}
                  onChange={handleNumberInputChange(setMediumPrice)}
                  onBlur={handleNumberInputBlur(setMediumPrice)}
                />
                <input
                  type="text"
                  className={`form-control mb-2 ${errors.largePrice ? "is-invalid" : ""}`}
                  placeholder="Large Price"
                  value={largePrice}
                  onChange={handleNumberInputChange(setLargePrice)}
                  onBlur={handleNumberInputBlur(setLargePrice)}
                />
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
            <button type="button" className="btn btn-success" onClick={handleSave}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
